import { Button, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './OffersPickerModalFooter.css';
import { EDeviceType } from '../../types/deviceType';

interface IProps {
  selectedIds: Array<number>;
  onApply(): void;
  onCancel(): void;
}

export const OffersPickerModalFooter = ({ selectedIds, onApply, onCancel }: IProps) => {
  const device = useDeviceType();
  const isMobile = device !== EDeviceType.Desktop;

  return (
    <div data-name="OfferPickerFooterButtons" className={style['buttons']}>
      <Button
        data-name="OfferPickerButton_cancel"
        disabled={!selectedIds.length}
        size="XS"
        theme="fill_white_primary"
        onClick={onCancel}
      >
        Сбросить
      </Button>
      <Button
        data-name="OfferPickerButton_apply"
        disabled={!selectedIds.length}
        size="XS"
        theme={isMobile ? 'fill_white_primary' : 'fill_primary'}
        onClick={onApply}
      >
        Отправить
      </Button>
    </div>
  );
};
